import { render, staticRenderFns } from "./ArrivalStatus.vue?vue&type=template&id=4adb189c"
import script from "./ArrivalStatus.vue?vue&type=script&lang=js"
export * from "./ArrivalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports